import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { MarketdateExpense } from './marketdate-expense.model';
import { MarketdateExpenseService } from './marketdate-expense.service';
@Injectable()
export class MarketdateExpensePopupService {
    private isOpen = false;
    constructor(
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private marketdateExpenseService: MarketdateExpenseService

    ) {}

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.marketdateExpenseService.find(id).subscribe((marketdateExpense) => {
                marketdateExpense.updated = this.datePipe
                    .transform(marketdateExpense.updated, 'yyyy-MM-ddThh:mm');
                marketdateExpense.created = this.datePipe
                    .transform(marketdateExpense.created, 'yyyy-MM-ddThh:mm');
                this.marketdateExpenseModalRef(component, marketdateExpense);
            });
        } else {
            return this.marketdateExpenseModalRef(component, new MarketdateExpense());
        }
    }

    marketdateExpenseModalRef(component: Component, marketdateExpense: MarketdateExpense): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.marketdateExpense = marketdateExpense;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-expense/marketdate-expense-popup.service.ts